export default {
    /* ========== GLOBAL ========== */
    global: {
        loading: "Loading",
        loadingDe: "Loading"
    },
    /* ========== LOGIN PAGE ========== */
    landingPage: {
        pageTitle: {
            top: "LRC Workplace",
            bottom: "spicetech-ek-crm-workplace Workplace",
        },
        features: [
        ]
    },
    /* ========== LOGIN PAGE ========== */
    loginPage: {
        signInTitle: "Login",
        signInDescription: "Login to your account.",
        loginButton: "Login",
    },
    /* ========== ACTIVATE PAGE ========== */
    activatePage: {
        title: "Account Activation",
        description: "Set your password.",
        button: "Activate",
    },
    /* ========== RESET PASSWORD PAGE ========== */
    resetPasswordPage: {
        title: "Reset Password",
        description: "Set your new password.",
        button: "Submit",
    },
    /* ========== FORGOT PASSWORD PAGE ========== */
    forgotPasswordPage: {
        title: "Forgot Password",
        description: "Submit your username! When your account is identified, we will send a you a reset an email.",
        button: "Submit",
    },
    /* ========== SIGN UP PAGE ========== */
    signUpPage: {
        signUpTitle: "Sign Up",
        requestRights: "Request the required rights.",
        signIn: "Already have an account?",
    },
    /* ========== CHATBOT ========== */
    chatbot: {
        noMessages: "No messages yet.",
        placeholder: "Start typing here...",
    },
    /* ========== APP CARD ========== */
    appCard: {
        contactPerson: "Support",
        accessProcess: "Process",
        tutorials: "Tutorials",
    },
    /* ========== CHANGE PASSWORD PAGE ========== */
    changePasswordPage: {
        button: "Submit",
    },
    /* ========== SETTINGS PAGE ========== */
    settingsPage: {
        account: {
            title: "Account",
        },
        dailyMailSubscription: {
            title: "Daily Mail",
            description: "",
        },
        realtimeMailSubscription: {
            title: "Subscribe to Real Time Notification Mail ",
            description: "Subscribe to the Real-Time Notification Mail option to receive instant email notification you are assigned a new task.",
        },
        proxy: {
            title: "Proxy",
            description: "Set a proxy to forward all incoming tasks in case of absence for a specified date.",
            // New Proxy Form
            nameLabel: "User",
            fromLabel: "From",
            toLabel: "To",
            addButton: "Add",
            userSuggestionLoadingText: "Loading",
            userSuggestionErrorText: "Could not fetch users.",
            userSuggestionNoResultsText: "Users must login at least once to the workplace in order to appear in the search.",
            departmentLabel: "Department",
        }
    }
};
